import { NgModule } from '@angular/core';
import { WorkItemCommentsComponent } from './components/work_item_comments/work_item_comments.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { RouterModule } from "@angular/router";
import { NzTypographyModule } from "ng-zorro-antd/typography";
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzProgressModule } from "ng-zorro-antd/progress";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzTagModule } from "ng-zorro-antd/tag";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzPaginationModule } from "ng-zorro-antd/pagination";
import { NzInputModule } from "ng-zorro-antd/input";
import { EvidenceWorkItemCardComponent } from "./components/evidence_work_item_card/evidence_work_item_card.component";
import { AssessmentTaskBrowserModalComponent } from "./components/assessment_task_browser_modal/assessment_task_browser_modal.component";
import { AssessmentTaskFormModalComponent } from "./components/assessment_task_form_modal/assessment_task_form_modal.component";
import { ThemeConstantService } from './services/theme_constant.service';
import { FormNavigationMenuComponent } from "./components/form_navigation_menu/form_navigation_menu.component";
import { LoadingIndicatorComponent } from "./components/loading_indicator/loading_indicator.component";
import { Cb4TableLoadingDirective } from "./directives/cb4_table_loading.directive";
import { TableEmptyStateComponent } from "./components/table_empty_state/table_empty_state.component";
import { FormPdfHistoryComponent } from "./components/form_pdf_history/form_pdf_history.component";
import { FormProgressSummaryComponent } from "./components/form_progress_summary/form_progress_summary.component";
import { FormPreviewComponent } from "./components/form_preview/form_preview.component";
import { ExpiredAssessmentComponent } from "./components/expired_assessment/expired_assessment.component";
import { EvidenceRequirementsModalComponent } from "./components/evidence_requirements_modal/evidence_requirements_modal.component";
import { AddUserModalModule } from "./components/add_user_modal/add_user_modal.module";

@NgModule({
    declarations: [
        WorkItemCommentsComponent,
        EvidenceWorkItemCardComponent,
        AssessmentTaskBrowserModalComponent,
        AssessmentTaskFormModalComponent,
        FormNavigationMenuComponent,
        LoadingIndicatorComponent,
        Cb4TableLoadingDirective,
        TableEmptyStateComponent,
        FormPdfHistoryComponent,
        FormProgressSummaryComponent,
        FormPreviewComponent,
        ExpiredAssessmentComponent,
        EvidenceRequirementsModalComponent
    ],
    exports: [
        WorkItemCommentsComponent,
        NzTypographyModule,
        AddUserModalModule,
        EvidenceWorkItemCardComponent,
        AssessmentTaskBrowserModalComponent,
        AssessmentTaskFormModalComponent,
        CommonModule,
        FormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NzButtonModule,
        NzIconModule,
        NzProgressModule,
        NzModalModule,
        NzSelectModule,
        FormNavigationMenuComponent,
        LoadingIndicatorComponent,
        Cb4TableLoadingDirective,
        TableEmptyStateComponent,
        FormPdfHistoryComponent,
        FormProgressSummaryComponent,
        FormPreviewComponent,
        ExpiredAssessmentComponent,
        EvidenceRequirementsModalComponent
    ],
    imports: [
        NzTypographyModule,
        AddUserModalModule,
        ReactiveFormsModule,
        NzPaginationModule,
        NzInputModule,
        DragDropModule,
        RouterModule,
        CommonModule,
        FormsModule,
        NzButtonModule,
        NzIconModule,
        NzToolTipModule,
        NzProgressModule,
        NzCardModule,
        NzTagModule,
        NzTableModule,
        NzAlertModule,
        NzSpinModule,
        NzModalModule,
        NzSelectModule,
        NzDatePickerModule,
        NzRadioModule
    ],
    providers: [
        ThemeConstantService
    ]
})

export class SharedModule { }
